// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"88be3c05","92":"de0eb676","99":"d6586b17","215":"5d106a44","337":"321cf68b","443":"fa1ec1d5","453":"145f7ee0","479":"92c07d42","531":"ead9ca5e","952":"cc5489e6"}[chunkId] + ".chunk.js";
};